import "./common.scss";
type ICardProps = {
  data: any, handleInput: any, sendInvitation: any, inputs: any
}
function InstructorStudentCard({ data, handleInput, sendInvitation, inputs }: ICardProps) {
  return (
    <div className="ins_std_home_card">
      <div className="bg_image" style={data?.title ? { bottom: -23 } : {}}>
        <img src={data.bgImage} alt="background" />
      </div>
      {data?.title && <h3 className="heading3">{data?.title}</h3>}
      <p className="text" dangerouslySetInnerHTML={{ __html: data?.text }}></p>
      <form action="">
        <label htmlFor="">{data?.formLabel}</label>
        <div className="input_row">
          <input type="email" placeholder="Email" value={inputs.toEmail} name="toEmail" onChange={handleInput} />
          <button className="button" onClick={sendInvitation}>{data?.buttonText}</button>
        </div>
      </form>
    </div>
  );
}

export default InstructorStudentCard;
